import React, { useEffect, useState } from 'react';
import { Form, message, Select } from 'antd';
import { addInsurAccount } from '@/services/insureManagement'
import { SFuncModal } from 'shj-components';
import { httpCompanyList } from '@/services/homeService';
import { projectExternalEmployeeList } from '@/services/externalPerson';

export function AddAndEditModel({ fn, ...rest }: any) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: '初始化保险账户',
    width: 500,
    vanish: true,
    content: <AddAndEdit onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}

const AddAndEdit = ({ onClose, fn, ...rest }: any) => {
  const FormItem = Form.Item;
  const { Option } = Select;
  const [form] = Form.useForm();

  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const [positionList, setPositionList] = useState([]);
  const [userList, setUserList] = useState([])
  const [companyIdList, setCompanyIdList] = useState('');
  const getCompanyList = async () => {
    const list: any = await httpCompanyList();
    setPositionList(list || []);
  };
  useEffect(() => {
    getCompanyList();
  }, []);
  const handleSubmit = () => {
    form.validateFields().then((values: any) => {
      setAddOrEditFooterLoading(true);
      addInsurAccount(values).then((response: any) => {
        if(response) {
          message.error(response)
        } else {
          message.success('操作成功')
          fn && fn();
          onClose();
        }
      })
        .finally(() => {
          setAddOrEditFooterLoading(false);
        });
    })
  };
  const onSearchOwnerUserList = (value = '',companyId?) => {
   const companyIdLists = companyId || companyIdList
    projectExternalEmployeeList(1, 50, {userCodeOrName: value, companyIds: [companyIdLists]}).then((response: any) => {
        setUserList(response?.records || [])
    });
}
  return (
    <SFuncModal.Content
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={addOrEditFooterLoading}>
      <Form form={form} layout="vertical">
        <FormItem
          label="门店"
          name="companyId"
          rules={[{ required: true, message: '请选择门店' }]}
        >
          <Select
            showSearch
            allowClear={true}
            filterOption={(input: any, option: any) => {
              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }}
            onChange={(val)=>{
              setCompanyIdList(val)
              onSearchOwnerUserList('', val)
              form.setFieldValue('extEmpId', null) 
            }}
          >
            {positionList.length && positionList.map((item: any, i: any) => {
              return (
                <Option key={i} value={item.orgId}>
                  {item.companyName}
                </Option>
              );
            })}
          </Select>
        </FormItem>
        <Form.Item
          label="人员"
          name="extEmpId"
          required
          rules={[{ required: true, message: '请选择人员' }]}
        >
          <Select
            showSearch
            allowClear={true}
            onSearch={onSearchOwnerUserList}
            filterOption={(input: any, option: any) => {
              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }}
          >
            {userList.length && userList.map((item: any, i: any) => {
              return (
                <Option key={i} value={item.id}>
                  {`${item.name}-${item.phone}`}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </Form>
    </SFuncModal.Content>
  );
};
